import { Appl } from '../../../core/Appl';
import { OraService } from './OraService';
import ApplyViewModel from './memberCreate/ApplyViewModel';
import { NavItem } from '../../../core/services/Models';
// import OraViewModel from './oraTest/OraViewModel';

export default class OraModule {

  public static MenuItems(): Array<NavItem> {

    let menuItems: Array<NavItem> = [];
    return menuItems
  }

  public static init(): void {
    Appl.Services.add('IOraService', OraService);
    // Appl.Services.add('OraViewModel', OraViewModel);
    Appl.Services.add('ApplyViewModel', ApplyViewModel);
  }
}
